import { render } from "./TopPage.vue?vue&type=template&id=a9679db0&scoped=true&ts=true"
import script from "./TopPage.vue?vue&type=script&lang=ts"
export * from "./TopPage.vue?vue&type=script&lang=ts"

import "./TopPage.vue?vue&type=style&index=0&id=a9679db0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9679db0"]])

export default __exports__